import Vue from 'vue';
import { Consoler } from './Consoler';

class ConfigDefinition extends Vue 
{
    public readonly GisServicesServicesUrl: string = process.env.VUE_APP_GIS_SERVICES_SERVICES_URL;
    public readonly DefaultMapCoordsLat: number = Number(process.env.VUE_APP_DEFAULT_MAP_COORDS_LAT);
    public readonly DefaultMapCoordsLng: number = Number(process.env.VUE_APP_DEFAULT_MAP_COORDS_LNG);
    public readonly MapProjection: string = process.env.VUE_APP_MAP_PROJECTION;
    public readonly MapMaxZoom: number = Number(process.env.VUE_APP_MAP_MAX_ZOOM);

    public readonly MapSetFullScreenEvent: string = 'mapSetFullScreen';
    public readonly MapPositionSelectedEvent: string = 'mapPositionSelected';
    public readonly MapRegionOfficeSelectedEvent: string = 'mapRegionOfficeSelected';
    public readonly MapClearPointsEvent: string = 'mapClearPoints';
    public readonly MapSetPointEvent: string = 'mapSetPoint';
    public readonly MapShowVoOrSboLayerEvent: string = 'mapShowVoOrSboLayer';
    public readonly MapToggleLegendEvent: string = 'mapSetHideLegend'
    
    public Settings: ConfigSettings = {
        ApiBaseUrl: ''
    };

    public SetSettings(settings: ConfigSettings) {
        Consoler.debugLog('Setting settings:', settings);
        this.Settings = settings;
    }
}

export interface ConfigSettings {
    ApiBaseUrl: string;
}

export const Config = new ConfigDefinition();